import { httpClient, unwrap } from '@/services/httpClient';
import type { LoginResult, MeResult } from '@/types/auth';

export interface RegisterPayload {
  first_name: string;
  last_name?: string;
  email: string;
  password: string;
  organization_name: string;
}

export interface LoginPayload {
  email: string;
  password: string;
  organization_id?: number;
  remember_me?: boolean;
}

export const authApi = {
  register: (payload: RegisterPayload) => unwrap<LoginResult>(httpClient.post('/auth/register', payload)),

  login: (payload: LoginPayload) => unwrap<LoginResult>(httpClient.post('/auth/login', payload)),

  loginWithGoogle: (idToken: string, organizationName?: string, organizationId?: number) =>
    unwrap<LoginResult>(httpClient.post('/auth/google', {
      id_token: idToken, organization_name: organizationName, organization_id: organizationId,
    })),

  logout: (refreshToken: string | null, everywhere = false) =>
    unwrap<null>(httpClient.post('/auth/logout', { refresh_token: refreshToken, everywhere })),

  me: () => unwrap<MeResult>(httpClient.get('/auth/me')),

  forgotPassword: (email: string) => unwrap<{ message: string }>(httpClient.post('/auth/forgot-password', { email })),

  resetPassword: (token: string, password: string) =>
    unwrap<{ message: string }>(httpClient.post('/auth/reset-password', { token, password })),

  verifyEmail: (token: string) => unwrap<{ message: string }>(httpClient.post('/auth/verify-email', { token })),

  resendVerification: () => unwrap<{ message: string }>(httpClient.post('/auth/resend-verification')),

  /** Re-scopes the session to a different organization the user belongs to, via refresh-token rotation. */
  refresh: (refreshToken: string, organizationId?: number) =>
    unwrap<LoginResult>(httpClient.post('/auth/refresh', { refresh_token: refreshToken, organization_id: organizationId })),
};
